module.exports = __webpack_public_path__ + "img/icon3.58356b6f.png";